import { Dispatch, SetStateAction, useState, VFC } from 'react'
import { RoundFilterListIcon } from 'src/assets/svgs'
import { TooltipWrapper } from 'src/components/Tooltip'
import { SmallButton } from 'src/elements/Button'
import { ContributionsQueryParam } from 'src/models/Contribution'
import { MasterData, MasterDataWithFieldType } from 'src/models/MasterData'
import {
  _filtertext,
  _profilegreen,
  contributionGray,
  truewhite,
} from 'src/styles/colors'
import styled from 'styled-components'
import { SearchCheckbox } from './SearchCheckbox'
import { SearchCheckboxFieldType } from './SearchCheckboxFieldType'
import { SearchFreeWord } from './SearchFreeWord'

type FilterProps = {
  onClickOpenMenu?: () => void
  onClickSearch: (q?: ContributionsQueryParam) => void
  selectedFreeWords: string[]
  setSelectedFreeWords: Dispatch<SetStateAction<string[]>>
  masterTypeOfPurchases?: MasterData[]
  selectedTypeOfPurchases: string[]
  setSelectedTypeOfPurchases: Dispatch<SetStateAction<string[]>>
  budgets?: MasterData[]
  selectedBudgets: string[]
  setSelectedBudgets: Dispatch<SetStateAction<string[]>>
  introductionTimings?: MasterData[]
  selectedIntroductionTimings: string[]
  setSelectedIntroductionTimings: Dispatch<SetStateAction<string[]>>
  specialties?: MasterDataWithFieldType[]
  selectedSpecialties: number[]
  setSelectedSpecialties: Dispatch<SetStateAction<number[]>>
}
export const Filter: VFC<FilterProps> = ({
  onClickOpenMenu,
  onClickSearch,
  selectedFreeWords,
  setSelectedFreeWords,
  masterTypeOfPurchases,
  selectedTypeOfPurchases,
  setSelectedTypeOfPurchases,
  budgets,
  selectedBudgets,
  setSelectedBudgets,
  introductionTimings,
  selectedIntroductionTimings,
  setSelectedIntroductionTimings,
  specialties,
  selectedSpecialties,
  setSelectedSpecialties,
}) => {
  const [openMenu, setOpenMenu] = useState<Boolean>(false)

  return (
    <FilterDiv>
      {!openMenu && (
        <FilteSetDiv>
          <FilterSettingButton
            onClick={() =>
              onClickOpenMenu ? onClickOpenMenu() : setOpenMenu(!openMenu)
            }
          >
            <TooltipWrapper
              direction={{ y: 'bottom' }}
              xValue={'-42px'}
              yValue={'16px'}
              tooltipNode={<LabelDiv>絞り込み条件を設定する</LabelDiv>}
            >
              <StyledRoundFilterListIcon />
            </TooltipWrapper>
          </FilterSettingButton>
        </FilteSetDiv>
      )}
      {openMenu && (
        <>
          <OuterDiv onClick={() => setOpenMenu(false)} />
          <FilterSettingButton onClick={() => setOpenMenu(!openMenu)}>
            <StyledRoundFilterListIcon />
          </FilterSettingButton>
          <FilterMenu>
            <FilterText>絞り込み条件の詳細</FilterText>
            <Scrollable>
              <SearchFreeWord
                title={'フリーワード'}
                selectedItems={selectedFreeWords}
                setSelectedItems={setSelectedFreeWords}
              />
              <SearchCheckbox
                title={'タイプ'}
                items={masterTypeOfPurchases}
                selectedItems={selectedTypeOfPurchases}
                setSelectedItems={setSelectedTypeOfPurchases}
              />
              <SearchCheckboxFieldType
                title={'分野'}
                items={specialties}
                selectedItems={selectedSpecialties}
                setSelectedItems={setSelectedSpecialties}
              />
              <SearchCheckbox
                title={'予算'}
                items={budgets}
                selectedItems={selectedBudgets}
                setSelectedItems={setSelectedBudgets}
              />
              <SearchCheckbox
                title={'導入時期'}
                items={introductionTimings}
                selectedItems={selectedIntroductionTimings}
                setSelectedItems={setSelectedIntroductionTimings}
              />
            </Scrollable>
            <Control>
              <ClearButton
                onClick={() => {
                  setSelectedFreeWords([])
                  setSelectedTypeOfPurchases([])
                  setSelectedSpecialties([])
                  setSelectedBudgets([])
                  setSelectedIntroductionTimings([])
                }}
              >
                リセット
              </ClearButton>
              <SubmitButton
                onClick={() => {
                  onClickSearch()
                  setOpenMenu(false)
                }}
              >
                検索
              </SubmitButton>
            </Control>
          </FilterMenu>
        </>
      )}
    </FilterDiv>
  )
}

const FilterDiv = styled.div`
  z-index: 1;
  position: relative;
  font-size: 14px;
  font-weight: 400;
`

const FilterMenu = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  right: -10px;
  width: 700px;
  padding: 24px 32px;
  border-radius: 10px;
  background-color: ${truewhite};
  box-shadow: 4px 8px 28px 0 #787878;
  display: flex;
  flex-wrap: wrap;
`

const FilterText = styled.div`
  color: ${_profilegreen};
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
`

const Control = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: end;
`

const ClearButton = styled(SmallButton)`
  margin: 0px 32px;
  color: ${contributionGray};
`

const SubmitButton = styled(SmallButton)`
  color: ${truewhite};
  background: ${_profilegreen};
`

const FilteSetDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

const FilterSettingButton = styled.button`
  display: block;
  color: ${_filtertext};
  background: ${truewhite};
  svg {
    path {
      fill: ${_filtertext};
    }
  }
`
const StyledRoundFilterListIcon = styled(RoundFilterListIcon)`
  margin-right: 8px;
`

const OuterDiv = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
`

const LabelDiv = styled.div`
  writing-mode: horizontal-tb;
`
const Scrollable = styled.span`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  height: 585px;
`
